module.exports = require('buffer')



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/~/safe-buffer/browser.js
// module id = 306
// module chunks = 1 5 6 7 9 10 11 13 15 16 22 23 25 29 30 59